import { Link } from "@freightsimple/ui-core/Typography/Link";
import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { T } from "@freightsimple/ui-core/Typography/T";
import { Tooltip } from "@freightsimple/ui-core/Feedback/Tooltip";

const BookShipmentAdditionalChargesQuestionBubble: React.FC = () => {
  return (
    <Tooltip
      interactive
      variant="info"
      content={
        <Stack gap={2}>
          <T size="xs" color="secondary">
            We require correct information to get accurate quotes, and avoid
            additional charges during shipping.
          </T>
          <Link
            href="https://help.freightsimple.com/freight-101/measuring-your-freight"
            external
          >
            Learn more
          </Link>
        </Stack>
      }
    />
  );
};
export default BookShipmentAdditionalChargesQuestionBubble;
